import { render, staticRenderFns } from "./DeliveryDetailDialog.vue?vue&type=template&id=89446b20&scoped=true"
import script from "./DeliveryDetailDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetailDialog.vue?vue&type=style&index=0&id=89446b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89446b20",
  null
  
)

export default component.exports